import React, { useState, useEffect } from "react";
import "./AdsManager.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.hostname !== "localhost" ? "/api" : "http://localhost:5000/api");

const AdsManager = ({ onSuccess, onError }) => {
  const [leftAds, setLeftAds] = useState([]);
  const [rightAds, setRightAds] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAds = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/ads`);
      const data = await res.json();
      setLeftAds(data.left_ads || []);
      setRightAds(data.right_ads || []);
    } catch (err) {
      onError("Không thể tải danh sách quảng cáo.");
    }
  };

  useEffect(() => {
    fetchAds();
  }, []);

  const handleUpload = async (e, side) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    formData.append("side", side);

    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/ads/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        onSuccess(`Đã tải lên ảnh cột ${side === "left" ? "trái" : "phải"}`);
        fetchAds();
      } else {
        onError(data.error || "Lỗi tải lên ảnh.");
      }
    } catch (err) {
      onError("Lỗi kết nối khi tải ảnh.");
    } finally {
      setLoading(false);
      e.target.value = null; // reset input
    }
  };

  const handleDelete = async (side, index) => {
    if (!window.confirm("Bạn có chắc chắn muốn xóa ảnh quảng cáo này?")) return;

    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/ads/${side}/${index}`, {
        method: "DELETE",
      });
      if (res.ok) {
        onSuccess("Đã xóa ảnh quảng cáo.");
        fetchAds();
      } else {
        onError("Lỗi xóa ảnh.");
      }
    } catch (err) {
      onError("Lỗi kết nối khi xóa ảnh.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-section" style={{ marginTop: "30px", borderTop: "1px solid #eee", paddingTop: "20px" }}>
      <h3>3. Quản Lý Quảng Cáo Nổi (Banners 2 bên)</h3>
      <p style={{ color: "#666", marginBottom: "20px" }}>
        Kích thước ảnh đề xuất: <strong>200x600 px</strong> hoặc <strong>200x800 px</strong>.
      </p>

      <div className="ads-columns">
        {/* Left Column */}
        <div className="ads-column">
          <h3>Ảnh Quảng Cáo Bên Trái</h3>
          <div className="ads-upload">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleUpload(e, "left")}
              disabled={loading}
              id="upload-left"
              style={{ display: "none" }}
            />
            <label htmlFor="upload-left" className="btn btn-primary" style={{ cursor: "pointer", display: "inline-block" }}>
              {loading ? "Đang tải lên..." : "Tải Ảnh Trái Lên"}
            </label>
          </div>
          <div className="ads-list">
            {leftAds.map((url, idx) => (
              <div key={idx} className="ad-item">
                <img src={`${process.env.REACT_APP_BACKEND_URL || (window.location.hostname !== "localhost" ? "" : "http://localhost:5000")}${url}`} alt={`Left Ad ${idx}`} />
                <button className="btn-small btn-delete" onClick={() => handleDelete("left", idx)}>Xóa</button>
              </div>
            ))}
            {leftAds.length === 0 && <p>Chưa có ảnh nào.</p>}
          </div>
        </div>

        {/* Right Column */}
        <div className="ads-column">
          <h3>Ảnh Quảng Cáo Bên Phải</h3>
          <div className="ads-upload">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleUpload(e, "right")}
              disabled={loading}
              id="upload-right"
              style={{ display: "none" }}
            />
            <label htmlFor="upload-right" className="btn btn-primary" style={{ cursor: "pointer", display: "inline-block" }}>
              {loading ? "Đang tải lên..." : "Tải Ảnh Phải Lên"}
            </label>
          </div>
          <div className="ads-list">
            {rightAds.map((url, idx) => (
              <div key={idx} className="ad-item">
                <img src={`${process.env.REACT_APP_BACKEND_URL || (window.location.hostname !== "localhost" ? "" : "http://localhost:5000")}${url}`} alt={`Right Ad ${idx}`} />
                <button className="btn-small btn-delete" onClick={() => handleDelete("right", idx)}>Xóa</button>
              </div>
            ))}
            {rightAds.length === 0 && <p>Chưa có ảnh nào.</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdsManager;
